import { useTranslation } from "react-i18next";
import { Tooltip } from "barte-design-system";
import { TrashIcon } from "@phosphor-icons/react";

import { formatDateToBr, formatPercentage } from "@shared/helpers";

import type { PendingAlreadyReviewedListItemProps } from "./pending-already-reviewed-list-item.type";
import styles from "./pending-already-reviewed-list-item.module.css";

export const PendingAlreadyReviewedListItem = ({
  item,
  isSkipped,
  onRemove,
}: PendingAlreadyReviewedListItemProps) => {
  const { t } = useTranslation();

  const taxTypeLabel = t(`enums.TAX_TYPE_${String(item.taxType).toUpperCase()}`);
  const title = item?.installment
    ? `${t("payfac.pagePendenciesShowInstallmentValue", { number: item.installment })} · ${taxTypeLabel}`
    : taxTypeLabel;

  const subtitle = [
    item.brand && t(`enums.BRAND_${String(item.brand).toUpperCase()}`),
    item.captureType && t(`enums.CAPTURE_${String(item.captureType).toUpperCase()}`),
    `#${String(item.id).padStart(4, "0")}`,
  ]
    .filter(Boolean)
    .join(" · ");

  const handleRemove = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onRemove(item.key);
  };

  return (
    <div className={`${styles.row} ${isSkipped ? styles["row-skipped"] : ""}`}>
      <div className={styles.info}>
        <p className={styles.title}>{title}</p>
        <p className={styles.sub}>{subtitle}</p>
        {item.consentedAt && (
          <Tooltip
            placement="right"
            label={t("payfac.pagePendenciesCarouselConsentedTooltip", {
              user: item.consentedByUser ?? "-",
            })}
          >
            <p className={styles["consented-meta"]}>
              {t("payfac.pagePendenciesCarouselConsentedMeta", {
                date: formatDateToBr(item.consentedAt),
              })}
            </p>
          </Tooltip>
        )}
      </div>
      <div className={styles.right}>
        <span className={styles.value}>{formatPercentage(item.currentValue)}</span>
        <button
          className={styles["btn-remove"]}
          onClick={handleRemove}
          title={t("payfac.pagePendenciesCarouselRemoveItem")}
        >
          <TrashIcon size={14} />
        </button>
      </div>
    </div>
  );
};
